export const customerTypes = [
  {
    label: "Retailer",
    value: "retailer",
    default: false,
  },
  {
    label: "Wholesaler",
    value: "wholesaler",
    default: true,
  },

  {
    label: "Other",
    value: "other",
    default: false,
  },
  {
    label: "Merchant",
    value: "merchant",
    default: false,
  },
];

export const supplierTypes = [
  {
    label: "Manufacturer",
    value: "manufacturer",
    default: true,
  },
  {
    label: "Stockiest",
    value: "stockiest",
    default: false,
  },
  {
    label: "Trader",
    value: "trader",
    default: false,
  },
  {
    label: "Other",
    value: "other",
    default: false,
  },
];
